const StarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="26"
    fill="none"
    viewBox="0 0 28 26"
    {...props}
  >
    <path
      fill="#FACC15"
      d="m14 0 3.143 9.674h10.172l-8.23 5.979 3.144 9.673L14 19.348l-8.229 5.978 3.143-9.673-8.229-5.98h10.172z"
    ></path>
  </svg>
);

export default StarIcon;
